import ApplicationAdapter from './application';

export default class PslfTemplateAdapter extends ApplicationAdapter {
  namespace = 'api/v2';
}
